<div class="brand-logo">
  <a href="/"
    class="d-flex align-items-center mx-4">
    <img src="assets/images/brands/app_logo.png"
      class="px-2" /></a>
</div>